const subscriptions = {};

export function unsubscribe(eventName, eventCallback) {
    if (!subscriptions[eventName]) return;

    subscriptions[eventName] = subscriptions[eventName].filter((fn) => fn !== eventCallback);
}

export function subscribe(eventName, eventCallback) {
    if (!subscriptions[eventName]) {
        subscriptions[eventName] = [];
    }
    subscriptions[eventName].push(eventCallback);

    return () => {
        unsubscribe(eventName, eventCallback);
    };
}

export function emit(eventName, eventData) {
    const eventSubscriptions = subscriptions[eventName];
    console.log("emit", { eventName, eventData })
    if (!eventSubscriptions) return;

    eventSubscriptions.forEach((fn) => {
        if (typeof fn !== "function") return;
        fn(eventData);
    });
}
